import DocumentUploadBig from "../../assets/images/run-payroll/document-upload.svg"
import "./payroll-process.scss"

const RunPayrollDropzone = ({
  handleUploadFile,
  uploadText = "Click or drag a CSV or XSL file to this area to upload",
  fileFormats,
  classes,
  disabled = false
}) => {
  return (
    <div className={`dropdown-zone ${classes || ""} ${disabled ? "disabled" : ""}`}>
      <input
        type="file"
        id="file-uploader"
        accept={fileFormats || ".csv"}
        onChange={handleUploadFile}
        disabled={disabled}
        multiple
      />
      <img loading="lazy" src={DocumentUploadBig} alt="" />
      <h6>{uploadText}</h6>
      <h6>Select file</h6>
    </div>
  )
}

export default RunPayrollDropzone
